import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import privacy from '@/pages/privacy'

//样式文件
import '@/assets/CSS/ly.css'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
        path:'/privacy',
        name:'privacy',
        component:privacy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js